<template>
  <div>
    <span>Please wait...</span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {googleLogin} from '@/api/login'

export default {
  created () {
    this.googleSignin(this.$route.fullPath)
  },
  methods: {
    ...mapActions(['SET_USER_INFO']),
    async googleSignin (fullPath) {
      const query = fullPath.split('?')[1]
      const callbackUrl = `${process.env.VUE_APP_API_URL}google/callback?${query}`

      try {
        const response = await googleLogin(callbackUrl)

        this.$store.dispatch('GoogleSSO', {
          access_token: response.data.data.access_token,
          user: response.data.data.user
        })

        this.showSuccessMessage('Success', 'Logged in', 'success')


        this.SET_USER_INFO(response.data.data.user)

        if (
          this.$store.getters.customerId === '' ||
          this.$store.getters.customerId === null
        ) {
          this.$router.push('/pages/switch').catch(() => {})
        } else {
          this.$router.push(this.$router.currentRoute.query.to || '/').catch(() => {})
        }
      } catch (e) {
        this.$router.push('/')
        this.showSuccessMessage('Error', 'Invalid Credentials', 'danger')
      }
    }
  }
}
</script>